import getStrapiCollectionData from '../src/integration/strapi.client';

const fetchInfo = async ({ collectionType, modalID }) => {
  try {
    const res = await getStrapiCollectionData(collectionType, modalID);

    return res;
  } catch (error) {
    console.error('error', error);
  }
};

export default fetchInfo;
